import client from '../httpClient';

const putSettingApi = async (params) => {
  const result = await client.put('/division-masters/setting', JSON.stringify(params), { isShowMessage: true });
  return result;
};

export default putSettingApi;
